import { put, select, takeLatest } from 'redux-saga/effects';

import { STEPS_OPEN_STEP_REQUEST, STEPS_SET_COMPLETED_REQUEST } from '../actions/actionTypes';
import { setCompletedStep, setCurrentStep } from '../actions/steps';
import { getCurrentStep } from '../reducers/wizard';

function* openStepSaga({ payload }) {
  try {
    yield select(getCurrentStep);

    yield put(setCurrentStep(payload));
  } catch (error) {
    //console.log('openStepSaga error', error);
  }
}

export function* openStepWatcher() {
  yield takeLatest(STEPS_OPEN_STEP_REQUEST, openStepSaga);
}

function* setStepCompletedSaga({ payload }) {
  try {
    yield put(setCompletedStep(payload));
  } catch (error) {
    console.log('setStepCompletedSaga error', error);
  }
}

export function* setStepCompletedWatcher() {
  yield takeLatest(STEPS_SET_COMPLETED_REQUEST, setStepCompletedSaga);
}
